<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapProductionOrders"
        :sel-reset="true"
        @reset="resetHandle"
        @select="selectHandle"
        @addOrEdit="addEditHandle"
    >
      <template slot="otherBtn">
        <el-button v-if="limits.printOrderAuth" type="primary" :disabled="!selection.length" @click="printOrder">
          工单打印
        </el-button>
        <el-button v-if="limits.wareHousePrintOrderAuth" type="primary" :disabled="!selection.length" @click="wareHousePrintOrder">
          生产领料打印
        </el-button>
        <el-button v-if="limits.combineAuth" :disabled="!selection.length" type="primary" @click="mergeIssue">
          合并发料
        </el-button>
        <el-button v-if="limits.manualAuth" type="primary" :disabled="!selection.length" @click="setConfirm">
          手动报工
        </el-button>
        <el-button type="primary" size="small" @click="handleExport">导出</el-button>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.genAuth" type="primary" :disabled="scope.row.isSnSerialNo === true" @click="getSn(scope.row)">
          生成序列号
        </el-button>
        <el-button v-if="limits.deliveryAuth" type="success" @click="postProduction(scope.row)">
          发料
        </el-button>
        <el-button v-if="limits.genAuth" :loading="bxLoading" type="info" @click="handleBX(scope.row)">
          报修
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工单编号">
            <el-input v-model.trim="filter.orders" placeholder="请输入工单编号" clearable/>
          </el-form-item>
          <el-form-item label="批量工单">
            <el-input v-model.trim="filter.ordersList" placeholder="请输入工单编号" type="textarea" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialDescription" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
          </el-form-item>
          <el-form-item label="过账状态">
            <el-select v-model="filter.status" clearable placeholder="请选择过账状态">
              <el-option label="全部" value="-1"/>
              <el-option label="待发料" value="0"/>
              <el-option label="部分发料" value="10"/>
              <el-option label="全部发料" value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="打印状态">
            <el-select v-model="filter.print" clearable placeholder="请选择打印状态">
              <el-option label="全部" value="-1"/>
              <el-option label="未打印" value="0"/>
              <el-option label="已打印" value="1"/>
            </el-select>
          </el-form-item>
          <el-form-item label="工单类型">
            <el-select v-model="filter.orderType" clearable placeholder="请选择工单类型">
              <el-option label="全部" value=""/>
              <el-option label="标准生产订单" value="GK01"/>
              <el-option label="试制生产订单" value="GK02"/>
              <el-option label="小批生产订单" value="GK03"/>
              <el-option label="改制生产订单" value="GK04"/>
              <el-option label="拆解生产订单" value="GK05"/>
              <el-option label="呆滞拆解订单" value="GK06"/>
              <el-option label="外购返修订单" value="GK07"/>
              <el-option label="研发整改订单" value="ZPP8"/>
            </el-select>
          </el-form-item>
          <el-form-item label="工序数量">
            <el-select v-model="filter.stationNumber" clearable placeholder="请选择工序数量">
              <el-option label="显示" :value="true"/>
              <el-option label="不显示" :value="false"/>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
                v-model="createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <dispatch-detail ref="dispatchDetail" @save-success="loadData"/>
    <merge-issue-print ref="mergeIssuePrint" @save-success="loadData"/>
    <production-post ref="productionPost" @save-success="loadData"/>
    <production-order-print ref="productionOrderPrint" @save-success="loadData"/>
    <el-dialog
        v-el-drag-dialog
        width="400px"
        :visible.sync="confirmDialogVisible"
        :close-on-click-modal="false"
        title="报工参数">
      <el-form
          ref="form"
          :model="confirmForm"
          class="form"
          label-width="120px">
        <el-row>
          <el-form-item label="工单号">
            <span>{{confirmForm.billNo}}</span>
          </el-form-item>
          <el-form-item label="物料号">
            <span>{{confirmForm.materialNo}}</span>
          </el-form-item>
          <el-form-item label="物料描述">
            <span>{{confirmForm.materialName}}</span>
          </el-form-item>
          <el-form-item label="工单类型">
            <span>{{confirmForm.orderType}}</span>
          </el-form-item>
          <el-form-item label="报工数量" prop="confirmQty">
            <el-input-number
                v-model="confirmForm.confirmQty"
                style="width: 100%"
                :min="0"/>
          </el-form-item>
          <el-form-item label="报工日期" prop="confirmDate">
            <el-date-picker
                v-model="confirmForm.confirmDate"
                style="width: 190px"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"/>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="confirmDialogVisible = false">取消</el-button>
        <el-button :loading="confirmLoading" type="primary" @click="confirmOrder(confirmForm)">报工</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import DispatchDetail from "./DispatchDetail.vue";
  import MergeIssuePrint from "@/views/ProductionManagement/ProductionOrder/MergeIssuePrint";
  import ProductionPost from "@/views/ProductionManagement/ProductionOrder/ProductionPost";
  import ProductionOrderPrint from "@/views/ProductionManagement/ProductionOrder/ProductOrderPrint";

  export default {
    name: "ProductionOrder",
    components: {ProductionOrderPrint, ProductionPost, MergeIssuePrint, ViewTable, DispatchDetail},
    data() {
      return {
        limits: {
          sureAuth: this.$auth(173),
          cancelAuth: this.$auth(174),
          printTagAuth: this.$auth(175),
          printOrderAuth: this.$auth(459),
          combineAuth: this.$auth(460),
          manualAuth: this.$auth(461),
          genAuth: this.$auth(462),
          deliveryAuth: this.$auth(468),
          wareHousePrintOrderAuth: this.$auth(35),
        },
        confirmDialogVisible: false,
        confirmLoading: false,
        bxLoading: false,
        workCenterList: [],
        selection: [],
        ids: [],
        createTimeRange: [],
        filter: {
          workCenterName: "",
          ordersList:"",
          status: "",
          orderType: "",
          orders: "",
          productionOrderNo: "",
          materialNo: "",
          materialName: "",
          materialDescription: "",
          warehousingStatus: "",
          customerName: "",
          salesOrderNo: "",
          customerContractNo: "",
          planStartFrom: "",
          planStartTo: "",
          planFinishFrom: "",
          planFinishTo: "",
          specification: "",
          createTimeBegin: "",
          createTimeEnd: "",
          stationNumber:false,
        },
        startDate: "",
        finishDate: "",
        confirmForm: {
          billNo: "",
          confirmQty: "",
          confirmDate: "",
          materialNo: "",
          materialName: "",
          orderType: "",
        },
        columnsProperty: [
          {
            key: "addDate",
            width: 160,
            align: "center",
          },
          {
            key: "materialNo",
            width: 120,
            align: "center",
          },
          {
            key: "materialDescription",
            width: 200,
            align: "center",
          },
          {
            key: "specification",
            width: 100,
            align: "center",
          },
          {
            key: "orderTypeName",
            width: 160,
          },
          {
            key: "orders",
            width: 150,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.dispatchDetail.open(params.row.pkId, true);
                    },
                  },
                },
                params.row.orders,
              );
            },
          },
          {
            key: "orderNum",
            width: 100,
            align: "center",
          },
          {
            key: "saleOrderNo",
            width: 150,
            align: "center",
          },
          {
            key: "projectNo",
            minWidth: 100,
          },
          {
            key: "productStart",
            width: 160,
            align: "center",
          },
          {
            key: "productEnd",
            width: 160,
            align: "center",
          },
          {
            key: "txt1",
            width: 160,
            align: "center",
          },
          {
            key: "completionTime",
            width: 160,
          },
          {
            key: "warehousingTime",
            width: 160,
            align: "center",
          },
          {
            key: "sapCustomerNo",
            width: 100,
            align: "center",
          },
          {
            key: "confirmQty",
            width: 100,
            align: "center",
          },
          {
            key: "instockQty",
            width: 100,
            align: "center",
          },
          {
            key: "schedulingTime",
            width: 90,
            align: "center",
          },
          {
            key: "warehouse",
            width: 90,
            align: "center",
          },
          {
            key: "sapSalesOrderNo",
            width: 120,
            align: "center",
          },
          {
            key: "sapSalesOrderRowIndex",
            width: 90,
            align: "center",
          },
          {
            key: "sapRepairReason",
            width: 130,
            align: "center",

          },
          {
            key: "sapNote",
            width: 120,
            align: "center",
          },
          {
            key: "sapChangeCategory",
            width: 120,
            align: "center",
          },
          {
            key: "feedingStatusName",
            width: 120,
            align: "center",
          },
          {
            key: "customerName",
            width: 120,
            align: "center",
          },
          {
            key: "actualStartTime",
            width: 120,
            align: "center",
          },
          {
            key: "S600001",
            width: 120,
            align: "center",
          },

          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    mounted() {
      this.getWorkCenters();
    },

    methods: {
      getWorkCenters() {
        this.$http.get("basic", "workCenters/employee/list").then((res) => {
          if (res.success) {
            this.workCenterList = res.data;
          }
        });
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      addEditHandle(row) {
        this.$refs.dispatchDetail.open(row.pkid);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      startDateChange(date) {
        if (date) {
          this.filter.planStartFrom = date[0];
          this.filter.planStartTo = date[1];
        } else {
          this.filter.planStartFrom = "";
          this.filter.planStartTo = "";
        }
      },

      finishDateChange(date) {
        if (date) {
          this.filter.planFinishFrom = date[0];
          this.filter.planFinishTo = date[1];
        } else {
          this.filter.planFinishFrom = "";
          this.filter.planFinishTo = "";
        }
      },

      // 标签打印
      printTag() {
        if (this.selection.length > 1) {
          this.$confirm("请选择一条数据打印", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((res) => {
          if (res.success) {
            if (res.data.length) {
              if (!res.data[0].prodType) {
                const params = {
                  unitName: this.selection[0].unitName,
                  materialName: this.selection[0].materialName,
                  spec: this.selection[0].specification,
                  billNo: this.selection[0].billNo,
                  salesOrderNo: this.selection[0].salesOrderNo,
                  data: res.data,
                };
                this.goTo("/materialsTagsPrint", JSON.stringify(params));
              } else {
                const params = {
                  orderInfo: this.selection[0],
                  data: res.data,
                };
                this.goTo("/productCardPrint", JSON.stringify(params));
              }
            }
          }
        });
      },

      // 工单打印
      printOrder() {
        if (this.selection.length === 0) {
          this.$confirm("请至少选择一条数据打印", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.gotoPrint(1);
      },
      // 生产领料打印
      wareHousePrintOrder() {
        if (this.selection.length === 0) {
          this.$confirm("请至少选择一条数据打印", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.gotoPrint(2);
      },

      gotoPrint(printType) {
        const routeUrl = this.$router.resolve({
          path: "/productManageOrderPrint",
          query: {
            ids: JSON.stringify(this.ids),
            printType,
          },
        });
        window.open(routeUrl.href, "_blank");
      },
      // 合并发料
      mergeIssue() {
        let orderNoList = [];
        let note = "";
        this.selection.forEach((item) => {
          orderNoList.push(item.orders);
          note = note + "生产订单：" + item.orders + " 物料号：" + item.materialNo + " 物料描述：" + item.materialDescription + "\n";
        });
        console.log(note);
        this.$refs.mergeIssuePrint.open(orderNoList, note);
      },
      // 跳转打印页面
      goTo(path, params) {
        const routeUrl = this.$router.resolve({
          path: path,
          query: {
            params: params,
          },
        });
        window.open(routeUrl.href, "_blank");
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
        this.ids = [];
        this.selection.forEach((item) => {
          this.ids.push(item.pkId);
        });
      },

      // 确认排产
      outputHandle() {
        const arr = this.selection.filter((item) => item.status !== 10);
        if (arr.length) {
          this.$confirm("请选择待排产的工单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$http.post("basic", "productionManage/scheduling", this.selection).then((resp) => {
          if (resp.success) {
            this.$message.success("排产成功");
            this.loadData();
            this.selection = [];
          }
        });
      },

      // 撤销排产
      cancelHandle() {
        const result = this.selection.filter((item) => item.status !== 20);
        if (result.length) {
          this.$confirm("请选择已排产的工单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$http.post("basic", "productionManage/cancel", this.ids).then((resp) => {
            if (resp.success) {
              this.$message.success("撤销成功");
              this.loadData();
              this.selection = [];
            }
          });
        }
      },

      getSn(row) {
        this.$http.get("basic", `sapProductionOrders/getSnBySnRule/${row.pkId}`)
          .then((res) => {
            if (res.success) {
              this.loadData();
            }
          });
      },
      handleBX(row) {
        this.$confirm("是否确认要进行报修？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.bxLoading = true;
          this.$http.get("basic", `repairRegistrations/batchBx/${row.pkId}`)
            .then((res) => {
              if (res.success) {
                this.loadData();
                this.bxLoading = false;
                this.$message.success("报修成功");
              }
            }).finally(() => {
              this.bxLoading = false;
            });
        }).catch(() => {
          this.bxLoading = false;
        });
      },
      postProduction(row) {
        this.$refs.productionPost.open(row.orders);
      },

      setConfirm() {
        if (this.selection.length > 1) {
          this.$message.error("请选择一条工单");
        }
        let order = this.selection[0];
        this.confirmForm.billNo = order.orders;
        this.confirmForm.materialNo = order.materialNo;
        this.confirmForm.materialName = order.materialDescription;
        this.confirmForm.confirmQty = order.orderNum - order.confirmQty;
        this.confirmForm.orderType = order.orderTypeName;
        this.confirmDialogVisible=true;
      },

      confirmOrder(confirm) {
        this.confirmLoading = true;
        this.$http.post("basic", "sapProductionOrders/confirmByHand", confirm).then((res) => {
          if (res.success) {
            this.$message.success("报工成功");
          }else{
            this.$message.error(res.message);
          }
        }).finally(() => {
          this.confirmLoading = false;
          this.confirmDialogVisible = false;
        });
      },

      resetHandle(filter) {
        this.startDate = "";
        this.finishDate = "";
        this.filter = filter;
      },

      handleExport() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "sapProductionOrders/exportOrderAndStation",this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
